<input [ngModel]="value"
       [style.border.px]="0"
       [style.background-color]="'initial'"
       [style.font-weight]="600"
       class="form-control"
       [formlyAttributes]="field"
       [class.is-invalid]="showError"
       [attr.aria-describedby]="id + '-formly-validation-error'"
       [attr.aria-invalid]="showError" />
